module.exports = __webpack_public_path__ + "img/laying-classica.d065e03e.svg";